import { Grid, type Theme, makeStyles } from '@material-ui/core';
import { type IMetadata } from 'src/models';
import {
	Pagination as MuiPagination,
	PaginationItem,
	type PaginationProps,
} from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) => ({
	item: {
		background: '#fff',
		fontWeight: 500,
	},
	pagination: {
		'& .Mui-selected': {
			background: '#fff',
			border: `1px solid ${theme.palette.secondary.main}`,
			color: theme.palette.secondary.main,
		},
	},
}));

interface Props {
	page?: number;
	metadata?: IMetadata;
	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[22:8]
	handlePagination?: (event: any, newPage: number) => void;
}

export function Pagination({
	handlePagination,
	metadata,
	page,
	...rest
}: Props & PaginationProps) {
	const classes = useStyles();

	return (
		<Grid alignItems={'center'} container justify={'flex-end'}>
			<MuiPagination
				className={classes.pagination}
				count={metadata?.totalPages}
				onChange={handlePagination}
				page={page}
				renderItem={(item) => (
					<PaginationItem className={classes.item} {...item} />
				)}
				shape={'rounded'}
				siblingCount={0}
				variant={'outlined'}
				{...rest}
			/>
		</Grid>
	);
}
